enum DiagnosticBoolean {
  TRUE = 10,
  FALSE = 20,
}

export default DiagnosticBoolean;